import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //  Keep user logged in between refreshes
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    //  Auto logout after 30 min inactivity
    let inactivityTimer;
    const autoLogout = async () => {
      try {
        await signOut(auth);
        localStorage.removeItem("cart");
      } catch (err) {
        console.error("Auto sign-out failed:", err);
      }
    };

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(autoLogout, 30 * 60 * 1000); // 30 min
    };

    //  Track user activity (mouse, keyboard, touch)
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("touchstart", resetTimer);
    resetTimer();

    window.addEventListener("unload", () => {
      if (performance.navigation.type === performance.navigation.TYPE_RELOAD)
        return; // při refreshi neodhlašuj
      localStorage.removeItem("cart");
      signOut(auth);
    });

    return () => {
      unsubscribe();
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("touchstart", resetTimer);
      clearTimeout(inactivityTimer);
    };
  }, []);

  const logout = async () => {
    try {
      localStorage.removeItem("cart");
      await signOut(auth);
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <AuthContext.Provider value={{ user, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
